import { Entry } from '../Entry'

export function Entry20230717() {
  return (
    <Entry title="Jul 17 2023 - v3.4.5">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13903/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
